import { useQueryState } from 'nuqs';

export const usePagination = (): any => {
  const [pageString, setPageString] = useQueryState('page');
  const [rowsPerPageString, setRowsPerPageString] =
    useQueryState('rowsPerpage');
  const pageNum = Number(pageString) || 1;
  const rowsPerPageNum = rowsPerPageString ? Number(rowsPerPageString) : 10;

  const setPage = async (page: string): Promise<void> => {
    await setPageString(page);
  };

  const setRowPerPage = async (rowPerPage: string): Promise<void> => {
    await setRowsPerPageString(rowPerPage);
  };

  const clearPagination = async (): Promise<void> => {
    await setPageString(null);
    await setRowsPerPageString(null);
  };

  const pagination = { page: pageNum, rowsPerPage: rowsPerPageNum };
  return { pagination, setPage, setRowPerPage, clearPagination };
};
